import { Magic } from "magic-sdk"
import axios from "../axiosInstance"

const magic = new Magic(process.env.REACT_APP_MAGIC_API_KEY ?? "")
  
export const authenticate = async (didToken: string) => {
  try {
    const res = await axios.post("/auth/login", {}, {
      headers: {
        'Content-Type': "application/json",
        Authorization: `Bearer ${didToken}`,
      },
      withCredentials: true,
    })
    const { data } = res
    if (data.mfaRequired) {
      // channel / destination say where the code went (text or email); see codeTargetFrom.
      return { mfaRequired: true, userId: data.userId, userType: data.userType, channel: data.channel, destination: data.destination, phoneLast4: data.phoneLast4 }
    }

    return data.user
  } catch (error) {
    console.error("Error authenticating user:", error)
    throw error
  }
}

export const fetchMe = async () => {
  try {
    const res = await axios.get("/auth/me")
    const { data } = res
    return data.user
  } catch (error) {
    console.error("Error fetching user:", error)
    throw error
  }
}

export const verifyOtp = async ({userId, otp, userType}: {userId: number, otp: string, userType: string}) => {
  try {
    const res = await axios.post("/auth/verify-otp", { userId, otp, userType }, { withCredentials: true })
    return res.data.user
  } catch (error) {
    console.error("Error verifying OTP:", error)
    throw error
  }
}

export const verifyPhone = async ({ otp }: { otp: string }) => {
  try {
    const res = await axios.post("/auth/verify-phone", { otp })
    return res.data
  } catch (error) {
    console.error("Error verifying phone:", error)
    throw error
  }
}

export const resendLoginOtp = async ({ userId, userType }: { userId: number, userType: string }) => {
  try {
    const res = await axios.post("/auth/resend-login-otp", { userId, userType })
    return res.data
  } catch (error) {
    console.error("Error resending login OTP:", error)
    throw error
  }
}

// channel "email": the client asked for the code by email ("Email me a code instead").
// purpose "two_factor": turning two-factor sign-in on or off, which must prove the phone,
// so the API never emails that code.
export const resendPhoneOtp = async (params?: { channel?: "email", purpose?: "two_factor" }) => {
  try {
    const res = await axios.post("/auth/resend-phone-otp", params ?? {})
    return res.data
  } catch (error) {
    console.error("Error resending phone OTP:", error)
    throw error
  }
}

export const logout = async () => {
  try {
    await axios.post("/auth/logout", {}, { withCredentials: true })
    await magic.user.logout()
  } catch (error) {
    console.error("Error logging out:", error)
    throw error
  }
}